// src/routes/GuestRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const GuestRoute = () => {
  const { authUser, loading } = useAuth();
  if (loading) return null;
  return authUser ? <Navigate to="/" replace /> : <Outlet />;
};
export default GuestRoute;
